import React, { PureComponent } from 'react';
import GroupBox from '../../common/groupBox/GroupBox';
import Pagination from '../../common/pagination/Pagination';
import {addDataIndex} from '../../../utils/util';
import { Table } from 'antd';
import { commonRequest } from '../common/commons';

export default class AntdTable extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            pageSize: 10,
            pageNum: 1,
            total: 0,
            tableData: []
        };
    }

    componentDidMount() {
        this.antdTablePort();
    }

    antdTablePort = () => {
        const {pageNum, pageSize} = this.state;
        // list 接口数据返回有list 和 results两种类型， 用于区分
        const {requestApi, list} = this.props;
        this.setState({
            loading: true
        });
        requestApi(commonRequest({pageNum: pageNum, pageSize: pageSize})).then(data => {
            data = data || {};
            this.setState({
                loading: false,
                total: data.total || 0,
                tableData: addDataIndex(list ? data.list : data.results, pageNum, pageSize)
            });
        }).finally(() => {
            this.setState({
                loading: false
            });
        });
    };

    pageChange = (pageNum, pageSize) => {
        this.setState({pageNum, pageSize}, () => {
            this.antdTablePort();
        });
    };

    render() {
        const {loading, tableData, total, pageNum, pageSize} = this.state;
        const {idName, title, columns, subTitle} = this.props;
        return (
            <GroupBox id={idName} title={title}>
                <div className="sub-title">{subTitle}</div>
                <Table
                    pagination={false}
                    loading={loading}
                    bordered
                    rowKey="index"
                    dataSource={tableData}
                    columns={columns}
                    footer={() => total > 10 ? <Pagination total={total} current={pageNum} pageSize={pageSize} onChange={this.pageChange} /> : null}
                />
            </GroupBox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/common/AntdTable.jsx